"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOrderStatusToString = transformOrderStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformOrderStatusToString(orderStatus) {
    switch (orderStatus) {
        case legacy_enums_1.OrderStatus.Pending:
            return legacy_enums_1.AffiliateOrderStatus.Pending;
        case legacy_enums_1.OrderStatus.Accepted:
            return legacy_enums_1.AffiliateOrderStatus.Accepted;
        case legacy_enums_1.OrderStatus.Declined:
            return legacy_enums_1.AffiliateOrderStatus.Declined;
        case legacy_enums_1.OrderStatus.Confirmed:
            return legacy_enums_1.AffiliateOrderStatus.Confirmed;
        case legacy_enums_1.OrderStatus.Cancelled:
            return legacy_enums_1.AffiliateOrderStatus.Cancelled;
        case legacy_enums_1.OrderStatus.Draft:
            return legacy_enums_1.AffiliateOrderStatus.Draft;
        case legacy_enums_1.OrderStatus.Reserved:
            return legacy_enums_1.AffiliateOrderStatus.Reserved;
        default:
            return "unknown status";
    }
}
//# sourceMappingURL=transformOrderStatusToString.js.map